import { Form, Formik } from 'formik';
import { Modal } from '@shared/components/modals/Modal';
import { newRoleFormSchema } from '../../validation';
import { IRole } from '../../shared';
import { NewRoleForm } from './NewRoleForm';

interface INewRoleModalProps {
  open: boolean;
  newRoleModalPosition: number;
  handleClose: () => void;
  handleSubmit: (data: IRole) => Promise<void>;
  currentRole: IRole | null;
}

export const NewRoleModal = ({ open, newRoleModalPosition, handleClose, handleSubmit, currentRole }: INewRoleModalProps) => {
  const initialState = {
    id: currentRole?.id,
    name: currentRole?.name || '',
    commentsColor: currentRole?.commentsColor || '#3784B0',
    commentsColorPriority: currentRole?.commentsColorPriority,
    permission: currentRole?.permissions?.[0] || '',
  };

  return (
    <Modal
      hideBackdrop
      title={`${!currentRole?.id ? 'New' : 'Edit'} Role`}
      open={open} 
      resetPosition={newRoleModalPosition}
      dialogWidth="40vw" 
      onClose={handleClose}
    >
      <Formik
        enableReinitialize
        initialValues={initialState as IRole}
        validationSchema={newRoleFormSchema}
        onSubmit={handleSubmit}
      >
        {(props) => (
          <Form onSubmit={props.handleSubmit}>
            <NewRoleForm handleClose={handleClose} {...props} />
          </Form>
        )}
      </Formik>
    </Modal>
  );
};
